const styles = (theme) => ({
  notificationIcon: {
    color: theme.palette.layout.textPrimary,
  },
})

export default styles
